import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";

// AIDEV-NOTE: Nic nerenderuje, jen zapisuje breadcrumb při každém commitu lokace routeru. Sentry si
// samo zapisuje navigation breadcrumb při history.pushState, takže vedle něj je vidět, jestli se
// lokace opravdu commitla (TD-467: v Safari občas ne). Jen pathname, ne search — v query jsou tokeny [TD-427].
export const RouterCommitBreadcrumb = (): null => {
  const location = useLocation();

  useLayoutEffect(() => {
    Sentry.addBreadcrumb({ category: "router.commit", data: { pathname: location.pathname } });
  }, [location.key]);

  return null;
};
